interface IPlaAndAdsData {
    Id: string;
    AdDetails: {
        Type: string;
        DestUrl: string;
        Title?: string;
        Description?: string;
        Page?: string;
    };
    TrafficShare?;
    Volume?: number;
    Position?: number;
    TopKeyword?: number;
    KeywordsCount?: number;
    LandingPage?: string;
}

export const transformAdsData = (type, data) => {
    let adsData = data?.Data || [];
    adsData = adsData.map((ad) => {
        const result: IPlaAndAdsData = {
            AdDetails: {
                Type: type === "text" ? "Text" : "Shopping",
                DestUrl: ad.DisplayUrl,
                Description: ad.Description,
                Title: ad.Title,
                Page: ad.LandingPage,
            },
            LandingPage: ad.LandingPage,
            Volume: ad.Volume,
            Position: ad.Position,
            TopKeyword: ad.TopKeyword,
            TrafficShare: ad.TrafficShare,
            KeywordsCount: ad.KeywordsCount,
            Id: ad.Id,
        };
        return result;
    });
    const adsTotalRows = data?.TotalCount || 0;
    return { data: adsData, TotalCount: adsTotalRows };
};
